import { render } from "./FilterReports.vue?vue&type=template&id=6156d1b9"
import script from "./FilterReports.vue?vue&type=script&lang=js"
export * from "./FilterReports.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__